import React from "react";
import {
    UserOutlined,
    PhoneOutlined,
    MailOutlined
} from '@ant-design/icons'
import api_url from '../../../utils/requestApi'
import appConst from '../../../constents/app.const'

class ProfileBox extends React.Component{
    constructor(props){
        super(props)
    }
    state={}
    componentDidMount(){}
    render(){
        return(
            <div className="">
                <div className="sidemenu-holder">
                    <div className="">
                        <div className="user-info">
                            <div className="profile-lg-img-holder">
                            <img src={appConst.apiUrl+api_url.profileImg+(this.props.userInfo?.image?this.props.userInfo.image:"pro.png")}/>
                            </div>
                        </div>
                            <div className="user-info-personal-info">
                                <h3>Personal Information</h3>
                                <UserOutlined /> {this.props.userInfo?.name}
                                <br/><UserOutlined /> {this.props.userInfo?.userId}
                                <br/><PhoneOutlined /> {this.props.userInfo?.mobile}
                                <br/><MailOutlined /> {this.props.userInfo?.email}
                            </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ProfileBox;